function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'spruce': 'rgb(86, 100, 98)','denim': 'rgb(92, 122, 150)','walnut': 'rgb(102, 90, 74)','maroon': 'rgb(145, 38, 56)','ivy': 'rgb(46, 59, 43)','drkbrown': 'rgb(110, 93, 77)','khaki': 'rgb(175, 156, 116)','blue': 'rgb(197, 202, 212)','navy': 'rgb(42, 49, 63)','brown': 'rgb(105, 87, 66)','red': 'rgb(172, 13, 26)','black': 'rgb(33, 30, 29)','white': 'rgb(255, 255, 255)','nat-blue': 'linear-gradient(135deg, #ECE1CE 50%, #5F6881 50%)','nat-yellow': 'linear-gradient(135deg, #ECE1CE 50%, #DEA408 50%)','nat-brown': 'linear-gradient(135deg, #ECE1CE 50%, #493327 50%)','navy-red': 'linear-gradient(135deg, #2A313F 50%, #AC0D1A 50%)','maroon-gold': 'linear-gradient(135deg, #912638 50%, #C99A2E 50%)','black-gold': 'linear-gradient(135deg, #211E1D 50%, #C99A2E 50%)','purple-white': 'linear-gradient(135deg, #4B2E83 50%, #FFFFFF 50%)','beige-tan': 'linear-gradient(135deg, #E3D5B8 50%, #B08D5E 50%)',};

    this.images = {};

    this.triggers = ['color','colour','couleur','farbe','cor',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
